import { requestApi } from 'utils';

export const getUserSubscriptionsApiRequest = () =>
  requestApi.query(`
      query GetUserSubscriptions {
        me {
          id
          subscriptions {
            id
            subscriptionPlanId
            validTil
            subscriptionPlan {
              id
              title
              zppCertified
              zppCourseGroupSlug
            }
          }
        }
      }
    `);
